/**
 * Careers
 */
(() => {
  const query = document.querySelector('.careers-form');
  if (!query) return;

  query.querySelector('.fake-email').remove();

  /* Sections */
  const firstSection = query.querySelector('section');

  document.querySelectorAll('.careers-form-section').forEach((item) => {
    query.append(item);
  });

  query.append(firstSection);

  /* Required */
  query.querySelectorAll('.form-control, .form-required').forEach((item) => {
    if (!item.required) return;

    if (item.closest('.col').querySelector('label')) {
      item.closest('.col').querySelector('label').innerHTML += ' <span>*</span>';
    }
  });

  /* CSV */
  const generateJSON = (form) => {
    const newForm = form.cloneNode(true);
    newForm.querySelectorAll('input[type="hidden"], .g-recaptcha-response').forEach((item) => {
      item.remove();
    });

    const formData = new FormData(newForm);
    const json = {};

    for (const [key, value] of formData) {
      json[key] = value;
    }

    return JSON.stringify(json);
  };

  query.addEventListener('submit', (e) => {
    if (query.querySelector('.customJSON')) {
      query.querySelector('.customJSON').setAttribute('value', generateJSON(e.target));
    } else {
      query.insertAdjacentHTML('beforeend', /* html */`
        <input class="hide customJSON" name="json" type="text" value='${generateJSON(e.target)}'/>
      `);
    }
  });
})();

/**
 * Clone Section
 */
(() => {
  const query = document.querySelectorAll('.clone-section');
  if (!query.length) return;

  query.forEach((item) => {
    const clone = item.querySelector('.clone-section-inner > *:last-of-type').cloneNode(true);

    let ele = document.createElement('div');
    ele.innerHTML = /* html */ `
      <a class="clone-section-add" href="javascript:;"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add a Row</a>
    `;
    ele = ele.firstElementChild;

    ele.addEventListener('click', () => {
      const newClone = clone.cloneNode(true);

      newClone.querySelectorAll('input, select, textarea').forEach((input) => {
        let i = 1;
        let { name } = input;

        while (document.querySelector(`[name*="${name}"]`) && i < 100) {
          i += 1;
          name = `${input.name}_${i}`;
        }
        input.name = name;
      });

      ele = document.createElement('div');
      ele.innerHTML = /* html */ `
        <a class="clone-section-remove" href="javascript:;"><i class="fa fa-minus-circle" aria-hidden="true"></i></a>
      `;
      ele = ele.firstElementChild;

      ele.addEventListener('click', () => {
        newClone.remove();
      });
      newClone.append(ele);

      item.querySelector('.clone-section-inner').append(newClone);
    });
    item.append(ele);
  });
})();

/**
 * data-disable-toggle
 */
(() => {
  const query = document.querySelectorAll('[data-disable-toggle]');
  if (!query.length) return;

  query.forEach((item) => {
    item.addEventListener('change', (e) => {
      document.querySelectorAll(`.${item.getAttribute('data-disable-toggle')}`).forEach((ele) => {
        ele.classList.toggle('disabled-area', e.checked);
      });
    });
  });
})();

/**
 * data-disable-enable
 */
(() => {
  const query = document.querySelectorAll('[data-disable-enable]');
  if (!query.length) return;

  query.forEach((item) => {
    item.addEventListener('change', (e) => {
      document.querySelectorAll(`.${item.getAttribute('data-disable-enable')}`).forEach((ele) => {
        ele.classList.toggle('disabled-area', false);
      });
    });
  });
})();

/**
 * data-disable-disable
 */
(() => {
  const query = document.querySelectorAll('[data-disable-disable]');
  if (!query.length) return;

  query.forEach((item) => {
    item.addEventListener('change', (e) => {
      document.querySelectorAll(`.${item.getAttribute('data-disable-disable')}`).forEach((ele) => {
        ele.classList.toggle('disabled-area', true);
      });
    });
  });
})();
